import {
    live_discussion_delete_message_path,
} from '~/routes';

export default function useDiscussionSettings({message, reloadMessages, setLoading, setContent, setEditingId}) {
    const {id, content} = message;
    const handleDeleteMessage = () => {
        setLoading(true);
        jQuery.post(live_discussion_delete_message_path({message_id: id}), {}, () => {
            reloadMessages();
            setLoading(false);
        })
    }

    const handleEditMessage = () => {
        setEditingId(id);
        setContent(content);
    }

    return {
        handleDeleteMessage,
        handleEditMessage
    }
}